/**
 * Compact recognized-layout banner for the transform-aware mapping phase.
 * column-mapping-ui spec, "Auto-suggest banner for a recognized layout":
 * explanatory text sits behind an info affordance, not inline.
 */
import { Sparkles } from 'lucide-react';
import { Button } from '@ooh/ui/components/button';
import { InfoHint } from '@ooh/ui/components/info-hint';

export interface MappingTransformsAutoSuggestBannerLabels {
  /** Fully formatted, e.g. "Rozpoznano układ kolumn z poprzedniego importu — dostawca Amb" */
  recognizedText: string;
  infoLabel: string;
  infoText: string;
  clearActionLabel: string;
}

export interface MappingTransformsAutoSuggestBannerProps {
  labels: MappingTransformsAutoSuggestBannerLabels;
  onClear: () => void;
}

export function MappingTransformsAutoSuggestBanner({
  labels,
  onClear,
}: MappingTransformsAutoSuggestBannerProps) {
  return (
    <div
      className="rounded-md bg-muted/40 px-3 py-1.5 flex items-center gap-2"
      data-testid="auto-suggest-banner"
    >
      <Sparkles className="h-3.5 w-3.5 text-muted-foreground shrink-0" strokeWidth={1.8} />
      <span className="text-xs text-muted-foreground">{labels.recognizedText}</span>
      <InfoHint label={labels.infoLabel}>{labels.infoText}</InfoHint>
      <Button
        type="button"
        variant="link"
        size="xs"
        className="ml-auto text-muted-foreground hover:text-foreground"
        onClick={onClear}
        data-testid="clear-auto-suggest"
      >
        {labels.clearActionLabel}
      </Button>
    </div>
  );
}
